import { Button, IconButton, Menu, paperClasses, styled, Typography, useTheme } from "@mui/material";
import { Stack } from "@mui/system";
import { CopyIcon } from "@phosphor-icons/react/dist/csr/Copy";
import { DotsThreeVerticalIcon } from "@phosphor-icons/react/dist/csr/DotsThreeVertical";
import { MouseEventHandler, useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { toast } from "react-toastify";
import { JSX } from "react/jsx-runtime";

const StackStyled = styled(Stack)({
  gap: "16px 4px",
  justifyContent: "center",
  padding: "8px 16px",
});

const CopyToClipboardButton = ({ id, typeId, onClick }: { id: string; typeId: string; onClick: () => void }) => {
  const theme = useTheme();

  return (
    <CopyToClipboard
      text={`${typeId}: ${id}`}
      onCopy={() => {
        onClick();
        toast.success("Copied to clipboard!");
      }}
    >
      <Button variant="text" sx={{ justifyContent: "flex-start", alignItems: "flex-start" }} aria-label="Copy ID">
        <CopyIcon size={24} color={theme.palette.text50.main} />
        <Typography
          variant="body.medium.regular"
          sx={{
            color: "text40.main",
            marginLeft: "4px",
          }}
        >
          Copy ID
        </Typography>
      </Button>
    </CopyToClipboard>
  );
};

const ActionsMenu = ({ children }: { children: (props: { closeModal: () => void }) => JSX.Element }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [showActions, setShowActions] = useState(false);

  const handleClick: MouseEventHandler<HTMLButtonElement> = (e) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
    setShowActions(true);
  };

  return (
    <>
      <IconButton data-testid={"menu-icon"} onClick={handleClick}>
        <DotsThreeVerticalIcon width="24px" height="24px" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={showActions}
        onClose={() => setShowActions(false)}
        sx={{ [`& .${paperClasses.root}`]: { borderRadius: "4px" } }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <StackStyled>{children({ closeModal: () => setShowActions(false) })}</StackStyled>
      </Menu>
    </>
  );
};

export { ActionsMenu, CopyToClipboardButton };
